import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { I18nLookup } from 'pricing-pages-lib/utils/languageUtils';
import { sortApiNamesByProductLevel } from 'pricing-pages-lib/utils/sortingUtils';
import { isFeatureRecord, isGrowthFeatureWithDefaultDescription } from 'pricing-pages-lib/utils/typeGuards';

const removeBreaks = content => {
  const formattedSections = [];

  if (!content) {
    return formattedSections;
  }

  const sections = content.split(/<br\/>|<br \/>/);
  sections.forEach((section, index) => {
    formattedSections.push( /*#__PURE__*/_jsx("p", {
      className: "m-all-0",
      children: section
    }, index));
  });
  return formattedSections;
};

// @TODO
// Translation request for es.pricing-pages.tooltips.labels.PROFESSIONAL to add space
const TranslatedFeature = ({
  feature,
  apiName,
  productLine,
  productLevel,
  attribute,
  needsProductLineIndexing,
  needsProductLevelIndexing,
  useFeatureStore = true
}) => {
  if (useFeatureStore) {
    if (attribute === 'name') return /*#__PURE__*/_jsx(_Fragment, {
      children: feature.displayName
    });

    if (isGrowthFeatureWithDefaultDescription(feature)) {
      if (attribute === 'description') {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: removeBreaks(feature.defaultDescription)
        });
      }
    }

    if (isFeatureRecord(feature)) {
      const featureKey = attribute === 'description' ? 'descriptions' : attribute;
      const {
        [featureKey]: translations
      } = feature;

      if (!translations) {
        return /*#__PURE__*/_jsx(_Fragment, {});
      }

      let translation = apiName && translations[apiName];

      if (translation) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: removeBreaks(translation)
        });
      }

      const highestTierProduct = sortApiNamesByProductLevel(feature.productApiNames).at(-1);
      translation = highestTierProduct && translations[highestTierProduct];

      if (translation) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: removeBreaks(translation)
        });
      }
    }
  } // sanitize key before looking it up in i18n


  const shortName = feature.shortName.trim();

  if (!needsProductLineIndexing) {
    const lookupVal = `pricing-pages.features.${shortName}.${attribute}`;

    if (I18nLookup(lookupVal)) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: lookupVal
      });
    }
  }

  if (needsProductLineIndexing && !needsProductLevelIndexing) {
    const hasHubSpecificLanguage = I18nLookup(`pricing-pages.features.${shortName}.${attribute}.${productLine}`);
    const keyToUse = hasHubSpecificLanguage ? productLine : 'default';
    const lookupVal = `pricing-pages.features.${shortName}.${attribute}.${keyToUse}`;

    if (I18nLookup(lookupVal)) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: lookupVal
      });
    }
  }

  if (needsProductLineIndexing && needsProductLevelIndexing) {
    const hasHubSpecificLanguage = I18nLookup(`pricing-pages.features.${shortName}.${attribute}.${productLine}`);
    const keyToUse = hasHubSpecificLanguage ? productLine : 'default';
    const lookupVal = `pricing-pages.features.${shortName}.${attribute}.${keyToUse}.${productLevel}`;

    if (I18nLookup(lookupVal)) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: lookupVal
      });
    }
  }

  return null;
};

export default TranslatedFeature;